import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import Breakpoints from '../../design-utils/breakpoints';

// This function creates a set of function that helps us create multipart component styles.
const helpers = createMultiStyleConfigHelpers([
  'CardContainer',
  'imageContainer',
  'content',
  'CardTitle',
  'price',
  'CardSubTitle',
  'CardSubSubTitle',
  'QuantityButton',
  'CustomMinusIcon',
  'CustomPlusIcon',
  'CardPrice',
  'CardButton',
  'QuantityButtonContainer',
  'Quantity',
  'AddButton',
  'Badge',
  'StarsContainer',
]);

const ProductCard = helpers.defineMultiStyleConfig({
  baseStyle: {
    CardContainer: {
      margin: 'auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: '16px',
      width: '220px',
      [`@media screen and (max-width: ${Breakpoints.md})`]: {
        width: '260px',
      },
      height: 'auto',
      textAlign: 'center',
      position: 'relative',
    },
    content: {
      width: '100%',
      height: '100%',
    },
    imageContainer: {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      background: 'transparent',
      position: 'relative',
    },
    CardTitle: {
      fontSize: '16px',
      fontWeight: '500',
      margin: '10px 0',
    },
    CardSubTitle: {
      fontSize: '16px',
      fontWeight: '600',
      lineHeight: '20px',
      textTransform: 'none',
      margin: '5px 0',
      color: '#637381',
    },
    CardSubSubTitle: {
      margin: '5px 0',
    },
    CustomMinusIcon: {
      width: '16px',
      height: '16px',
    },
    CustomPlusIcon: {
      width: '16px',
      height: '16px',
    },
    CardPrice: {
      margin: '0',
      marginTop: '0',
      fontWeight: '600',
      fontSize: '16px',
      lineHeight: '20px',
      width: '100%',
      span: {
        fontWeight: '600',
        fontSize: '14px',
        lineHeight: '20px',
        marginLeft: '10px',
      },
      color: '#637381',
    },
    CardButton: {
      marginTop: '10px',
      fontSize: 'max(1em, 12px)',
      lineHeight: 'max(1em, 20px)',
      color: '#ffffff',
      fontWeight: '700',
      background: '#000000',
      textAlign: 'center',
      borderRadius: '4px',
      padding: '8px 20px',
      boxSizing: 'border-box',
      maxHeight: '100%',
      width: '100%',
      '&:disabled': {
        backgroundColor: '#dfe3e8',
      },
    },
    QuantityButtonContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      border: '1px solid #c4cdd5',
      padding: '12px',
      borderRadius: '22px',
      fontWeight: '400',
      fontSize: '14px',
      width: '140px',
      margin: '0 auto',
      maxHeight: '44px',
      background: '#f6f6f6',
      '&[data-available="true"]': {
        background: 'transparent',
      },
    },
    QuantityButton: {
      background: 'none',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'initial',
      height: 'initial',
      '&:hover': {
        backgroundColor: 'initial',
      },
      '&:disabled': {
        visibility: 'hidden',
      },
    },
    AddButton: {
      background: 'none',
      border: 'none',
      display: 'inline-block',
      fontSize: '14px',
      fontWeight: '500',
      color: '#000000',
      cursor: 'pointer',
      '&:hover': {
        opacity: 0.8,
      },
    },
    Badge: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      backgroundColor: '#000000',
      color: '#ffffff',
      fontSize: '12px',
      fontWeight: '600',
      padding: '4px 8px',
      borderRadius: '2px',
      zIndex: 2,
      textTransform: 'uppercase',
    },
    StarsContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '0.5rem auto',
      fontSize: '1.7rem',
    },
    Quantity: {
      ':disabled': {
        opacity: '0.3',
      },
    },
  },
  sizes: {},
  variants: {},
  defaultProps: {},
});

export default ProductCard;
